import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { ALL_MEDAL_PROPERTIES } from '../../types/medalProperties';
import { PanelItem } from '../panelItem';
import { MedalImageDisplay } from './medalImageDisplay';
const CONTAINER_CSS = css `
  display: inline-flex;
  flex-flow: row wrap;
  gap: 5px;
`;
export const MedalImagesContainer = ({ username, medals }) => {
    const visibleMedals = medals
        .map((medal) => {
        const { getImageUrl } = ALL_MEDAL_PROPERTIES[medal.type];
        const imageUrl = getImageUrl?.(medal);
        return imageUrl ? { medalType: medal.type, name: medal.name, imageUrl } : undefined;
    })
        .filter((medal) => !!medal);
    if (!visibleMedals.length) {
        return null;
    }
    return (_jsx(PanelItem, { children: _jsx("div", { css: CONTAINER_CSS, "aria-label": `${username}'s Medals`, children: visibleMedals.map((visibleMedal, i) => (_jsx(MedalImageDisplay, { medalName: visibleMedal.name, imageUrl: visibleMedal.imageUrl }, i))) }) }));
};
